import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import './encourageScroll.css';

class EncourageScroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bottom: false
    };
  }

  isBottom() {
    const el = document.getElementById('encourage-scroll');
    return el.clientHeight / (el.scrollHeight - el.scrollTop) > 0.9;
  }

  componentDidMount() {
    this.trackScrolling();
    document
      .getElementById('encourage-scroll')
      .addEventListener('scroll', this.trackScrolling);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.bottom !== this.state.bottom) {
      this.trackScrolling();
    }
  }

  trackScrolling = () => {
    this.setState({ bottom: this.isBottom() });
  };

  render() {
    const { children, className = '' } = this.props;
    const { bottom } = this.state;
    return (
      <div id="encourage-scroll" className={className}>
        {children}
        <div
          className={`encourage-scroll__bar ${
            bottom || window.innerWidth < 768
              ? 'encourage-scroll__bar--hidden'
              : ''
          }`}>
          {' '}
          <div> Scroll Down </div> <FontAwesomeIcon icon={faChevronDown} />{' '}
        </div>
      </div>
    );
  }
}

export default EncourageScroll;



// WEBPACK FOOTER //
// ./src/components/EncourageScroll/index.js